export default "__VITE_ASSET__C5c7Hbo0__$_?url__"